import React, { useEffect, useState } from "react"
import { Card, CardBody, Row, CardTitle } from "reactstrap"
import axios from "axios"
import config from "config/config"
import { useSelector } from "react-redux"
import DesktopMacOutlinedIcon from "@mui/icons-material/DesktopMacOutlined"
import PhoneIphoneOutlinedIcon from "@mui/icons-material/PhoneIphoneOutlined"
import TabletMacOutlinedIcon from "@mui/icons-material/TabletMacOutlined"

const MonthlyEarnings = props => {
  const [deviceData, setDeviceData] = useState([])
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const mode = useSelector(state => state.Layout.layoutMode)

  useEffect(() => {
    const fetchDeviceData = async () => {
      try {
        const analyticsData = activeOrganization?.GoogleAnalyticsIntegrations[0]
        if (!analyticsData) {
          console.error("No Google Analytics Integration found")
          return
        }

        const response = await axios.get(
          `${config.backendUrl}/analytics/getReport?accessToken=${analyticsData.accessToken}&propertyId=${analyticsData.propertyId}&accountId=${analyticsData.accountId}`,
        )

        const data = response.data
        const deviceCategoryData = {}

        data.rows.forEach(row => {
          const deviceCategory = row.dimensionValues[3]?.value || "Unknown"
          const activeUsers = Number(row.metricValues[0]?.value || 0)
          deviceCategoryData[deviceCategory] =
            (deviceCategoryData[deviceCategory] || 0) + activeUsers
        })

        const devices = Object.entries(deviceCategoryData).map(
          ([device, count]) => ({
            device,
            count,
          }),
        )
        setDeviceData(devices)
      } catch (error) {
        console.error("Error fetching Google Analytics data:", error)
      }
    }

    if (activeOrganization) {
      fetchDeviceData()
    }
  }, [activeOrganization])

  const maxCount = Math.max(...deviceData.map(d => d.count), 1)

  // Function to get the appropriate icon based on device type
  const getDeviceIcon = deviceName => {
    const deviceLower = deviceName.toLowerCase()
    if (deviceLower.includes("desktop")) {
      return (
        <DesktopMacOutlinedIcon
          style={{ fontSize: "2rem", color: "#2990DF" }}
        />
      )
    } else if (deviceLower.includes("mobile")) {
      return (
        <PhoneIphoneOutlinedIcon
          style={{ fontSize: "2rem", color: "#2990DF" }}
        />
      )
    } else if (deviceLower.includes("tablet")) {
      return (
        <TabletMacOutlinedIcon style={{ fontSize: "2rem", color: "#2990DF" }} />
      )
    } else {
      return (
        <DesktopMacOutlinedIcon
          style={{ fontSize: "2rem", color: "#2990DF" }}
        />
      )
    }
  }

  return (
    <React.Fragment>
      <Card
        className="br"
        style={{
          overflowY: "hidden",
          minHeight: "517px",
          maxHeight: "517px",
          marginBottom: "0rem",
          paddingBottom: "0",
        }}
      >
        <CardBody
          style={{
            paddingBottom: "0.5rem",
          }}
        >
          <CardTitle className="h4 mb-4">Device Usage Statistics</CardTitle>

          <Row
            className="mb-2"
            style={{
              marginLeft: 0,
              marginRight: 0,
            }}
          >
            {deviceData.map(({ device, count }, index) => (
              <div className="col-4" key={index}>
                <div
                  style={{
                    padding: "15px 10px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: mode === "dark" ? "transparent" : "#fff",
                    borderRadius: "8px",
                    textAlign: "center",
                    boxShadow:
                      mode === "dark"
                        ? "0 4px 8px rgba(0, 0, 0, 0.2)"
                        : "0 4px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  {getDeviceIcon(device)}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginLeft: "20px",
                    }}
                  >
                    <h3
                      style={{
                        fontSize: "2rem",
                        fontWeight: "600",
                        marginBottom: "0.5rem",
                        marginTop: "0.5rem",
                        color: mode === "dark" ? "#fff" : "#000",
                      }}
                    >
                      {count}
                    </h3>
                    <p
                      style={{
                        fontSize: "0.9rem",
                        color: "#8D949C",
                        marginBottom: 0,
                      }}
                    >
                      {device.charAt(0).toUpperCase() + device.slice(1)}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Row>

          {/* Bar Chart */}
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "space-around",
              height: "280px",
              marginTop: "1.2rem",
              paddingLeft: "2rem",
              paddingRight: "2rem",
              position: "relative",
              boxSizing: "border-box",
            }}
          >
            {deviceData.map(({ device, count }, index) => {
              const barHeight = (count / maxCount) * 250
              return (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flex: 1,
                    maxWidth: "120px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: `${barHeight}px`,
                      backgroundColor: "#2990DF",
                      borderRadius: "4px 4px 0 0",
                      transition: "height 0.3s ease",
                    }}
                  />
                </div>
              )
            })}
          </div>

          {/* X-axis labels */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              paddingLeft: "2rem",
              paddingRight: "2rem",
              marginTop: "0.3rem",
              boxSizing: "border-box",
            }}
          >
            {deviceData.map(({ device }, index) => (
              <div
                key={index}
                style={{
                  flex: 1,
                  maxWidth: "120px",
                  textAlign: "center",
                }}
              >
                <p
                  style={{
                    fontSize: "0.85rem",
                    color: mode === "dark" ? "#8D949C" : "#495057",
                    marginBottom: "0",
                  }}
                >
                  {device.charAt(0).toUpperCase() + device.slice(1)}
                </p>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default MonthlyEarnings
